import { render, staticRenderFns } from "./dlg_insurance_type.vue?vue&type=template&id=9201244e&"
import script from "./dlg_insurance_type.vue?vue&type=script&lang=js&"
export * from "./dlg_insurance_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports